import React from "react";
import "./error.scss";
import NotFoundImage from "../../assets/images/404-image.png"; // Provide the actual image URL
import { Helmet } from "react-helmet-async";

const PageNotFoundComponent = () => {
  return (
    <>
      <Helmet>
        <title>404 Not Found | SLP</title>
      </Helmet>
      <div className="not-found-container">
        <img
          className="not-found-image"
          src={NotFoundImage}
          alt="404 Not Found"
        />
        <h1 className="not-found-text">Oops! Page not found</h1>
        <p className="not-found-description">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
      </div>
    </>
  );
};

export default PageNotFoundComponent;
